import classnames from "classnames";
export const modalClasses = (pos: string = "left") =>
  classnames(`modal modal-${pos} fade`);
export const modalImgClasses = (imgStyle: number) =>
  classnames(`modal-body-image-${imgStyle} bg-image background-fifty-percent`);
